<!-- Info/Loading/Ready Section -->
<ng-container *ngIf="urSimUrl$ | async as urSimUrl; else notReady">
  <!-- URSim Viewer (shown after container starts) -->
  <div class="ur-sim-view">
    <iframe
      [src]="urSimUrl"
      width="1280"
      height="800"
      frameborder="0"
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      allow="camera; microphone; fullscreen; autoplay; clipboard-write"
      title="URSim"
    ></iframe>
    <mat-card class="psx-preview-download-card">
      <p>
        <strong>1. Add .urcapx under System Manager -> URCaps</strong><br>
        <strong>2. Add .urpx under System Manager -> Programs</strong><br>
        <strong>3. Go to Application -> Pally -> License -> Get trial license</strong><br>
        <strong>4. Go to Program -> Press + -> Add the Pally node</strong><br>
        <strong>5. Press Play</strong><br>
      </p>
      <p>
        Passwords are <strong>"ursafe"</strong> and <strong>"easybot"</strong>
      </p>
      <p>
        If the robot enters a "Fault" state, please select a different program in Step 2 and then return to the Pally Demo program to continue.
      </p>
    </mat-card>
  </div>
</ng-container>

<!-- Not Ready: either 'nothing' or 'loading' -->
<ng-template #notReady>
  <ng-container *ngIf="starting; else infoSection">
    <!-- Loading State -->
    <div class="ur-sim-loading">
      <p>Starting your URSim container... This may take a few moments.</p>
    </div>
  </ng-container>
</ng-template>

<!-- Initial Info Section (shown before URSim starts) -->
<ng-template #infoSection>
  <div class="ur-sim-info">
    <h3>Preview for Polyscope X</h3>
    <h4>1. Download .urpx</h4>
    <mat-card class="psx-preview-download-card">
      <p>
        Download the .urpx file to your computer. This file contains the
        necessary configuration for Pally to work with Polyscope X.
      </p>
      <p>
        After downloading, you can import this file into Polyscope X > System
        Manager > Programs
      </p>
      <button mat-raised-button color="primary" (click)="downloadUrPx()">
        <mat-icon>
          <span>download</span>
        </mat-icon>
        <span>Download .urpx</span>
      </button>
    </mat-card>
    <h4>2. Download .urcapx</h4>
    <mat-card class="psx-preview-download-card">
      <p>
        Download the URCapX file to your computer. This file is essential for
        integrating Pally with Polyscope X.
      </p>
      <p>
        After downloading, you can install this URCap in Polyscope X > System
        Manager > URCaps
      </p>
      <button mat-raised-button color="primary" (click)="downloadUrCap()">
        <mat-icon>
          <span>download</span>
        </mat-icon>
        <span>Download URCapX</span>
      </button>
    </mat-card>
    <h4>3. Start Polyscope X</h4>
    <mat-card class="psx-preview-download-card">
      <p>
        To preview the Pally interface in Polyscope X, click the button below to
        start a URSim container. This allows you to interact with the robot UI
        in a simulated environment.
      </p>
      <p>
        Please note: it may take up to a minute for the container to start.
        We’ll display the interface once it’s ready.
      </p>
      <button
        mat-raised-button
        color="primary"
        (click)="startUrSimContainer()"
        [disabled]="starting"
      >
        <mat-icon>
          <span>play_arrow</span>
        </mat-icon>
        <span>Start</span>
      </button>
    </mat-card>
  </div>
</ng-template>
